// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Left Section: Logo & Copyright */}
        <div className="footer-left">
          <div className="footer-logo">
            {/* Uncomment if you have a logo image */}
            <img src="logo.jpg" alt="LeftRightSolutions Logo" />
            <span className="company-name">LeftRightSolutions</span>
          </div>
          <p>© {new Date().getFullYear()} LeftRightSolutions</p>
        </div>

        {/* Right Section: Footer Links */}
        <div className="footer-right">
          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="/overview">Overview</a></li>
              <li><a href="/customers">Customers</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <Link to="/"><li><a href="/about">Home</a></li></Link>
              <Link to="/about"><li><a href="/jobs">About</a></li></Link>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><a href="/faqs">FAQs</a></li>
              <Link to="/contact"><li><a href="/contact">Contact us</a></li></Link>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Legal</h4>
            <ul>
              <li><a href="/terms">Terms</a></li>
              <li><a href="/privacy">Privacy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
